import React from "react"
import { graphql } from "gatsby"
import Layout from "gatsby-theme-blank/src/components/Layout/layout"
import SEO from "gatsby-theme-blank/src/components/seo"
import AdditionalInformation from "gatsby-theme-blank/src/components/additional-information"
import {
  pageEventAdditionalInfos,
  eventImg,
  eventPlaceIcon,
  eventPlaceTitle,
  pageEvent,
  gridAriane,
  gridContent,
  gridDate,
  gridResume,
  gridTags,
  gridTitle,
  gridPlace,
  eventTitle,
  eventContentFooterBack,
  eventContentFooter,
  editButton,
} from "./styles/detailsEvent.module.scss"
import PropTypes from "prop-types"
import {
  AdditionalInfos,
  EventImg,
  EventDate,
  EventPlaceIcon,
  EventPlaceTitle,
  EventFooterContainer,
  EventTitle,
  EventTaxo,
  EventItemRecurrence,
} from "./styled-components/evenement-styled"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import Ariane from "gatsby-theme-blank/src/components/Ariane/ariane"
import SocialPanel from "gatsby-theme-blank/src/components/SocialMedias/social-panel"
import { ContentSplitter } from "gatsby-theme-blank/src/components/ContentSplitter/content-splitter"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"
import { LightBoxImage } from "gatsby-theme-blank/src/components/LightBoxImage/light-box-image"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query ($slug: String!) {
    nodeEvenements(path: { alias: { eq: $slug } }) {
      ...EventItem
    }
  }
`

//-----------------------QueryGraphql---------------------------//

//-----------------------Parent component---------------------------//

const EvenementTemplate = ({ data, location }) => {
  const nodeEvenement = data.nodeEvenements
  const allTaxos = nodeEvenement.relationships.field_taxonomie_thematique
    .map((taxo) => {
      return taxo.name
    })
    .join()
  return (
    <Layout isDetail={true}>
      <SEO
        title={nodeEvenement.title}
        description={
          "Dans cette page, vous découvrez l'évènement suivant : " +
          nodeEvenement.title +
          ", mais aussi l'ensemble des thématiques suivantes : " +
          allTaxos
        }
        nodeImageUrl={
          nodeEvenement.relationships?.field_image_event?.localFile
            ?.SlugifiedPublicUrl
        }
      />
      <div className={pageEvent}>
        <EventImgComponent nodeEvenement={nodeEvenement} />
        <div className={gridAriane}>
          <Ariane
            pageNameLink="/evenements"
            pageName="Tous les évènements"
            isDetail={true}
            postName={nodeEvenement.title}
          />
        </div>
        <EventDateComponent nodeEvenement={nodeEvenement} />
        <EventPlace nodeEvenement={nodeEvenement} />
        <div className={gridTitle}>
          <EditButton
            link={"/node/" + nodeEvenement.drupal_internal__nid + "/edit"}
            addedClass={editButton}
          />
          <EventTitle className={eventTitle}>{nodeEvenement.title}</EventTitle>
        </div>
        <EventTags nodeEvenement={nodeEvenement} />
        <EvenementContent nodeEvenement={nodeEvenement} />
      </div>

      <EvenementContentFooter
        nodeEvenement={nodeEvenement}
        location={location.href}
      />
      <EvenementInfos nodeEvenement={nodeEvenement} />
    </Layout>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Child component/Content---------------------------//

const EvenementContent = ({ nodeEvenement }) => {
  return (
    <>
      <ContentSplitter
        node={nodeEvenement}
        resumeClassName={gridResume}
        contentClassName={gridContent}
        splitPoint={625}
      />
    </>
  )
}

//-----------------------Child component/Tags---------------------------//

const EventTags = ({ nodeEvenement }) => {
  return (
    <>
      {nodeEvenement.relationships.field_taxonomie_thematique && (
        <div className={gridTags}>
          <p>Thématique</p>
          <p role={"list"}>
            {nodeEvenement.relationships.field_taxonomie_thematique.map(
              (taxo, index) => {
                if (
                  index ===
                  nodeEvenement.relationships.field_taxonomie_thematique
                    .length -
                    1
                ) {
                  return (
                    <EventTaxo key={taxo.name} role={"listitem"}>
                      <TransitionFade link={taxo.path.alias}>
                        {taxo.name}
                      </TransitionFade>
                    </EventTaxo>
                  )
                }
                return (
                  <EventTaxo key={taxo.name} role={"listitem"}>
                    <TransitionFade link={taxo.path.alias}>
                      {taxo.name},&nbsp;
                    </TransitionFade>
                  </EventTaxo>
                )
              }
            )}
          </p>
        </div>
      )}
    </>
  )
}

//-----------------------Child component/Tags---------------------------//

//-----------------------Child component/Img---------------------------//

const EventImgComponent = ({ nodeEvenement }) => {
  return (
    <EventImg className={eventImg}>
      {nodeEvenement.relationships?.field_image_event && (
        <LightBoxImage
          type={"node"}
          node={{
            alt: nodeEvenement.field_image_event.alt,
            file: nodeEvenement.relationships.field_image_event.localFile,
          }}
        />
      )}
    </EventImg>
  )
}

//-----------------------Child component/Img---------------------------//

//-----------------------Child component/Date---------------------------//

const EventDateComponent = ({ nodeEvenement }) => {
  return (
    <EventDate className={gridDate}>
      {!nodeEvenement.fields.formatted_field_date_de_fin ? (
        <span>Le {nodeEvenement.fields.formatted_field_date_de_debut}</span>
      ) : (
        <>
          <span>Du {nodeEvenement.fields.formatted_field_date_de_debut}</span>
          <span> au {nodeEvenement.fields.formatted_field_date_de_fin}</span>
        </>
      )}

      {nodeEvenement.field_evenement_recurrent && (
        <EventItemRecurrence>Récurrent</EventItemRecurrence>
      )}
    </EventDate>
  )
}

//-----------------------Child component/Date---------------------------//

//-----------------------Child component/Place---------------------------//

const EventPlace = ({ nodeEvenement }) => {
  return (
    <>
      {nodeEvenement.field_url_lieu && (
        <div className={gridPlace}>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={nodeEvenement.field_url_lieu.uri}
          >
            <EventPlaceIcon
              className={eventPlaceIcon}
              size={30}
              icon="location2"
            ></EventPlaceIcon>
            <EventPlaceTitle className={eventPlaceTitle}>
              {nodeEvenement.field_url_lieu.title}
            </EventPlaceTitle>
          </a>
        </div>
      )}
    </>
  )
}

//-----------------------Child component/Place---------------------------//

//-----------------------Child component/Footer---------------------------//

const EvenementContentFooter = ({ nodeEvenement, location }) => (
  <>
    <EventFooterContainer className={eventContentFooter}>
      <div className={eventContentFooterBack}>
        <TransitionFade arialabel="Retour aux évènements" link="/evenements">
          Retour aux évènements
        </TransitionFade>
      </div>
      <div>
        <SocialPanel location={location} postData={nodeEvenement} />
      </div>
    </EventFooterContainer>
  </>
)

//-----------------------Child component/Footer---------------------------//

//-----------------------Child component/Infos---------------------------//

const EvenementInfos = ({ nodeEvenement }) => (
  <>
    {nodeEvenement.field_infos_complementaires && (
      <AdditionalInfos className={pageEventAdditionalInfos}>
        <AdditionalInformation node={nodeEvenement} />
      </AdditionalInfos>
    )}
  </>
)

//-----------------------Child component/Infos---------------------------//

//-----------------------Styled component---------------------------//

//-----------------------Styled component---------------------------//

//-----------------------Prop-Types---------------------------//

EvenementTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object,
}
EvenementContent.propTypes = {
  nodeEvenement: PropTypes.object.isRequired,
}
EvenementInfos.propTypes = {
  nodeEvenement: PropTypes.object.isRequired,
}
EventPlace.propTypes = {
  nodeEvenement: PropTypes.object.isRequired,
}
EventDateComponent.propTypes = {
  nodeEvenement: PropTypes.object.isRequired,
}
EventTags.propTypes = {
  nodeEvenement: PropTypes.object.isRequired,
}
EventImgComponent.propTypes = {
  nodeEvenement: PropTypes.object.isRequired,
}
EvenementContentFooter.propTypes = {
  nodeEvenement: PropTypes.object.isRequired,
  location: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default EvenementTemplate
